<template>
    <div class="table-responsive">
        <table class="table-bordered table">
            <colgroup>
                <col style="width: 200px" />
                <col style="width: auto" />
                <col style="width: 150px" />
                <col style="width: 150px" />
            </colgroup>
            <tbody>
                <tr>
                    <th>■CP概要</th>
                    <th></th>
                    <th>1次チェック</th>
                    <th>2次チェック</th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_3(dataObject, isPreview)['応募フォーム']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                v-model="SWITCH_FIELD_TAB_3(dataObject)['応募フォーム']"
                                switch
                                @change="toggleCommonSwitch($event, { registration_form: dataObject.registration_form })"
                            />
                            応募フォーム
                        </div>
                    </td>
                    <td>
                        <div
                            :class="`d-flex box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['応募フォーム'] ? 'disabled_input' : ''}`"
                            :style="{
                                'background-color':
                                    isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['応募フォーム'] ? '' : '#ffffff',
                                gap: '0.5rem'
                            }"
                        >
                            <div class="form-group" style="max-width: 50%; flex: 1">
                                <div class="text-center text-nowrap mb-1" style="min-width: 100%; font-weight: 600">フォームのURL</div>
                                <div v-for="itemForm in detailBeginForDocument.forms" :key="`link-${itemForm.id}`" class="pl-2">
                                    <a
                                        v-if="itemForm.status === STATUS_FORM_LIST.PUBLISHING && !itemForm.is_first_create"
                                        :href="getFormUrl(itemForm)"
                                        target="_blank"
                                        :class="`d-block element__span ${isPreview || !SWITCH_FIELD_TAB_3(dataObject)['応募フォーム'] ? 'text--not-allowed' : ''}`"
                                        >{{ getFormUrl(itemForm) }}</a
                                    >
                                    <span v-else class="element__span">{{ getFormUrl(itemForm) }}</span>
                                </div>
                            </div>
                            <div style="border-right: 1px solid #ccc"></div>
                            <div class="form-group" style="max-width: 50%; flex: 1">
                                <div class="text-center text-nowrap mb-1" style="min-width: 100%; font-weight: 600">管理画面のURL</div>
                                <div v-for="itemForm in detailBeginForDocument.forms" :key="`manager-form-${itemForm.id}`" class="pl-2">
                                    <a
                                        :href="`${localtionForm}/manager-form/analytics?id=${itemForm.id}`"
                                        target="_blank"
                                        :class="`d-block element__span ${isPreview || !SWITCH_FIELD_TAB_3(dataObject)['応募フォーム'] ? 'text--not-allowed' : ''}`"
                                        >{{ `${localtionForm}/manager-form/analytics?id=${itemForm.id}` }}</a
                                    >
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.registration_form_first)"
                            v-model="dataObject.registration_form.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('registration_form', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.registration_form_secondary)"
                            v-model="dataObject.registration_form.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('registration_form', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_3(dataObject, isPreview)['■CP概要その他先_3']">
                    <td class="bg-color1">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_3(dataObject)['■CP概要その他先_3']"
                            @change="toggleCommonSwitch($event, { free_block_campaign_overview: dataObject.free_block_campaign_overview })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_campaign_overview.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['■CP概要その他先_3']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['■CP概要その他先_3'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td>
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_campaign_overview.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-■CP概要その他先_3-${idTab}`"
                            :model.sync="dataObject.free_block_campaign_overview.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['■CP概要その他先_3'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>
                <tr>
                    <th colspan="4">■応募数報告</th>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_3(dataObject, isPreview)['応募フォーム']">
                    <tr>
                        <td rowspan="2" class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    v-model="SWITCH_FIELD_TAB_3(dataObject)['報告スケジュール']"
                                    switch
                                    @change="
                                        toggleCommonSwitch($event, {
                                            reporting_schedule: dataObject.reporting_schedule,
                                            reporting_schedule_detail: dataObject.reporting_schedule_detail
                                        })
                                    "
                                />
                                報告スケジュール
                            </div>
                        </td>
                        <td
                            :class="{
                                disabled_cursor: isDisabled
                            }"
                        >
                            <CommonMultiselect
                                v-model="dataObject.reporting_schedule.data"
                                :options.sync="option.reporting_schedule"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['報告スケジュール']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_first)"
                                v-model="dataObject.reporting_schedule.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('reporting_schedule', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_secondary)"
                                v-model="dataObject.reporting_schedule.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('reporting_schedule', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab3-textarea-1"
                                :model.sync="dataObject.reporting_schedule_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['報告スケジュール']"
                                :isPreview="isPreview"
                                :config="inputConfig.reporting_schedule_detail"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_detail_first)"
                                v-model="dataObject.reporting_schedule_detail.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('reporting_schedule_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_detail_secondary)"
                                v-model="dataObject.reporting_schedule_detail.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('reporting_schedule_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <template v-if="SWITCH_FIELD_TAB_3(dataObject, isPreview)['報告内容']">
                    <tr>
                        <td rowspan="2" class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    v-model="SWITCH_FIELD_TAB_3(dataObject)['報告内容']"
                                    switch
                                    @change="
                                        toggleCommonSwitch($event, {
                                            contents_of_report: dataObject.contents_of_report,
                                            contents_of_report_detail: dataObject.contents_of_report_detail
                                        })
                                    "
                                />
                                報告内容
                            </div>
                        </td>
                        <td
                            :class="{
                                disabled_cursor: isDisabled
                            }"
                        >
                            <CommonMultiselect
                                v-model="dataObject.contents_of_report.data"
                                :options.sync="option.contents_of_report"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['報告内容']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_first)"
                                v-model="dataObject.contents_of_report.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_secondary)"
                                v-model="dataObject.contents_of_report.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab3-textarea-2"
                                :model.sync="dataObject.contents_of_report_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['報告内容']"
                                :isPreview="isPreview"
                                :config="inputConfig.contents_of_report_detail"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_detail_first)"
                                v-model="dataObject.contents_of_report_detail.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_detail_secondary)"
                                v-model="dataObject.contents_of_report_detail.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_3(dataObject, isPreview)['テスト応募']">
                    <tr>
                        <td rowspan="2" class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_3(dataObject)['テスト応募']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            test_application_1: dataObject.test_application_1,
                                            test_application_2: dataObject.test_application_2
                                        })
                                    "
                                />
                                テスト応募
                            </div>
                        </td>
                        <td>
                            <TextareaComponent
                                id="tab3-textarea-3"
                                :model.sync="dataObject.test_application_1.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['テスト応募']"
                                :isPreview="isPreview"
                                :config="inputConfig.test_application_1"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.test_application_1_first)"
                                v-model="dataObject.test_application_1.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('test_application_1', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.test_application_1_secondary)"
                                v-model="dataObject.test_application_1.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('test_application_1', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab3-textarea-4"
                                :model.sync="dataObject.test_application_2.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['テスト応募']"
                                :isPreview="isPreview"
                                :config="inputConfig.test_application_2"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.test_application_2_first)"
                                v-model="dataObject.test_application_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('test_application_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.test_application_2_secondary)"
                                v-model="dataObject.test_application_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('test_application_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <tr v-if="SWITCH_FIELD_TAB_3(dataObject, isPreview)['■応募数報告その他先_3']">
                    <td class="bg-color1">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_3(dataObject)['■応募数報告その他先_3']"
                            @change="toggleCommonSwitch($event, { free_block_report_number: dataObject.free_block_report_number })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_report_number.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['■応募数報告その他先_3']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['■応募数報告その他先_3'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td>
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_report_number.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-■応募数報告その他先_3-${idTab}`"
                            :model.sync="dataObject.free_block_report_number.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['■応募数報告その他先_3'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>

                <tr>
                    <th colspan="4">■その他(特記)</th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_3(dataObject, isPreview)['無効内容の詳細']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_3(dataObject)['無効内容の詳細']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        invalid_content: dataObject.invalid_content
                                    })
                                "
                            />
                            無効内容の詳細
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab3-textarea-5"
                            :model.sync="dataObject.invalid_content.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['無効内容の詳細']"
                            :isPreview="isPreview"
                            :config="inputConfig.invalid_content"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.invalid_content_first)"
                            v-model="dataObject.invalid_content.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('invalid_content', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.invalid_content_secondary)"
                            v-model="dataObject.invalid_content.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('invalid_content', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_3(dataObject, isPreview)['その他連絡事項']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_3(dataObject)['その他連絡事項']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        other_information: dataObject.other_information
                                    })
                                "
                            />
                            その他連絡事項
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab3-textarea-6"
                            :model.sync="dataObject.other_information.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['その他連絡事項']"
                            :isPreview="isPreview"
                            :config="inputConfig.other_information"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_information_first)"
                            v-model="dataObject.other_information.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_information', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_information_secondary)"
                            v-model="dataObject.other_information.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_information', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_3(dataObject, isPreview)['フリーブロックその他先']">
                    <td class="bg-color1">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_3(dataObject)['フリーブロックその他先']"
                            @change="toggleCommonSwitch($event, { free_block_other: dataObject.free_block_other })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_other.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['フリーブロックその他先']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['フリーブロックその他先'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td>
                        <div v-if="isNotCheckBoxPartner || isDisabled" class="box--text__disabled" v-html="dataObject.free_block_other.data"></div>
                        <Editor
                            v-else
                            :id="`editor-${idTab}`"
                            :model.sync="dataObject.free_block_other.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_3(dataObject)['フリーブロックその他先'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import CommonMultiselect from './CommonMultiselect.vue';
import Editor from '@/components/Editor/main.vue';
import editorDelayMixin from '@/mixins/editorDelayMixin';
import CommonCheckbox from './CommonCheckbox.vue';
import TextareaComponent from '@/components/Textarea/main.vue';

import { formatDateTimeJapanese, toggleCommonSwitch, isRolePartner, onHandleDataCheckValueForPartner } from '@/views/pages/require/handlers';
import { SWITCH_FIELD_TAB_3, configHelperOptions, CONFIG_INPUT_TAB_3 } from '@/views/pages/require/const-field-tab';
import { STATUS_FORM_LIST } from '@/views/pages/phase2/manager-form/constants';

export default {
    name: 'Tab3Require',
    mixins: [editorDelayMixin],
    props: {
        isNotCheckBoxPartner: {
            type: Boolean,
            default: () => false
        },
        keyTab: {
            type: [String],
            default: ''
        },
        idTab: {
            type: [String, Number],
            default: ''
        },
        dataObject: {
            type: Object,
            required: false
        },
        currentUser: {
            type: Object,
            required: false
        },
        detailBeginForDocument: {
            type: Object,
            required: false
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        isPreview: {
            type: Boolean,
            default: false
        },
        processingFields: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        CommonMultiselect,
        Editor,
        CommonCheckbox,
        TextareaComponent
    },
    data() {
        return {
            STATUS_FORM_LIST,
            domain: process.env.VUE_APP_DOMAIN_LP,
            localtionForm: window.location.origin,
            option: configHelperOptions.optionTab3,
            isRolePartner: isRolePartner(),
            inputConfig: CONFIG_INPUT_TAB_3()
        };
    },
    methods: {
        getFormUrl(item) {
            const domainForm = item?.domain || process.env.VUE_APP_DOMAIN_FORM;
            return `https://${domainForm}/form/${item.url_public}`;
        },
        formatDateTimeJapanese,
        toggleCommonSwitch,
        SWITCH_FIELD_TAB_3,

        handleCheckBoxValue(fieldName, type) {
            const payload = onHandleDataCheckValueForPartner(this.keyTab, this.dataObject, fieldName);
            this.$emit('handleTabCheckBoxValue', { payload, fieldName, type });
        }
    },
    watch: {},
    mounted() {}
};
</script>

<style lang="scss" scoped>
.box8 input[type='text'] {
    width: 200px;
}

.box8 textarea.form-control {
    //width: 400px;
}
</style>
